import(/* webpackMode: "eager" */ "/var/www/rallly/apps/web/src/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogIdentify"] */ "/var/www/rallly/apps/web/src/app/[locale]/posthog-identify.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimeZoneChangeDetector"] */ "/var/www/rallly/apps/web/src/app/[locale]/timezone-change-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView"] */ "/var/www/rallly/apps/web/src/app/posthog-page-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/var/www/rallly/apps/web/src/components/user-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreferencesProvider"] */ "/var/www/rallly/apps/web/src/contexts/preferences.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandingProvider"] */ "/var/www/rallly/apps/web/src/features/branding/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/rallly/apps/web/src/features/theme/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/var/www/rallly/apps/web/src/i18n/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagsProvider"] */ "/var/www/rallly/apps/web/src/lib/feature-flags/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSync"] */ "/var/www/rallly/apps/web/src/lib/locale/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimezoneProvider"] */ "/var/www/rallly/apps/web/src/lib/timezone/client/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCProvider"] */ "/var/www/rallly/apps/web/src/trpc/client/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectedDayjsProvider"] */ "/var/www/rallly/apps/web/src/utils/dayjs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyMotion","domAnimation"] */ "/var/www/rallly/node_modules/.pnpm/motion@12.9.2_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/motion/dist/es/motion/lib/react.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/rallly/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_react-d_c7bcc3645aa344a7961b7f5a61b010de/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/var/www/rallly/packages/posthog/src/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/rallly/packages/ui/src/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/var/www/rallly/packages/ui/src/tooltip.tsx");
